import React, {Dispatch, SetStateAction, useState} from 'react';
import s from "./ChangeEmail.module.css";
import MyBtn from "../ui/MyBtn/MyBtn";
import CustomModal from "../ui/CustomModal/CustomModal";
import MyInput from "../ui/MyInput/MyInput";
import {useFormik} from "formik";
import TransparentButton from "../ui/TransparentButton/TransparentButton";
import Icon from "@ant-design/icons";
import {ReactComponent as Back} from "../../assets/newImg/personalAccount/back.svg";
import {useAppDispatch, useAppSelector} from "../../hooks/redux";
import {
    getNewEmailThunk,
    sendConfirmationCodeThunk,
    sendNewEmailThunk,
    setTokenState
} from "../../store/reducers/ActionCreators";
import {setDisabled} from "../../store/reducers/UserSlice";
import * as yup from "yup";

type PropsType = {
    setIsChangeEmailProcess: Dispatch<SetStateAction<boolean>>
    isChangeEmailProcess: boolean
}

const validationSchemaEmail = yup.object({
    email: yup.string().email("invalid format").required('Required field'),
})

const ChangeEmail = (props: PropsType) => {

    const [isVerifyModalOpen, setIsVerifyModalOpen] = useState(false)
    const [isErrorModalOpen, setIsErrorModalOpen] = useState(false)
    const [isErrorText, setIsErrorText] = useState('Something went wrong. Please try again later.')
    const [newEmail, setNewEmail] = useState('')
    const dispatch = useAppDispatch()
    const token = useAppSelector(state => state.userReducer.user.userToken)

    const formikEmail = useFormik({
        initialValues: {
            email: '',
        },
        enableReinitialize: true,
        validationSchema :validationSchemaEmail,
        onSubmit: (values, formikHelpers) => {
            dispatch(sendNewEmailThunk(values, token))
                .then(() => {
                    setIsVerifyModalOpen(true)
                    setNewEmail(values.email)
                })
                .catch((e: any) => {
                    if (e.response.data === 'This email exists, please use other email') {
                        setIsErrorText('This email exists, please use other email')
                    }
                    setIsErrorModalOpen(true)
                })
                .finally(() => {
                    dispatch(setDisabled(false))
                })
        }
    })

    const formikEmailVerify = useFormik({
        initialValues: {
            code: '',
        },
        onSubmit: (values, formikHelpers) => {
            const tempData = {
                ...values,
                email: newEmail
            }
            dispatch(sendConfirmationCodeThunk(tempData, token))
                .then(() => {
                    formikHelpers.resetForm()
                    dispatch(getNewEmailThunk(token))
                    setIsVerifyModalOpen(false)
                    props.setIsChangeEmailProcess(false)
                })
                .catch((e: any) => {
                    if (e.response.data === "Invalid authorization data") {
                        dispatch(setTokenState(false))
                    } else {
                        setIsErrorText('Invalid email code')
                        setIsErrorModalOpen(true)
                    }
                    formikHelpers.resetForm()
                })
                .finally(() => {
                    dispatch(setDisabled(false))
                })
        }
    })

    return (
        <>
            <CustomModal isModalOpen={props.isChangeEmailProcess} setIsModalOpen={props.setIsChangeEmailProcess} type={"confirm"}>
                <form onSubmit={formikEmail.handleSubmit} className={s.from_wrapper}>
                    <div className={s.modal_title}>
                        Change the email address
                    </div>
                    <div className={s.input_block}>
                        <div className={s.input_label}>
                            New email address
                        </div>
                        <MyInput
                            value={formikEmail.values.email}
                            onChange={formikEmail.handleChange}
                            id={"email"}
                            name={"email"}
                            isError={!!formikEmail.errors.email}
                            touched={formikEmail.touched.email}
                        />
                        {formikEmail.errors.email && <div className={s.error_field}>{formikEmail.errors.email}</div>}
                    </div>
                    <div className={s.buttonsWrapper}>
                        <TransparentButton
                            buttonType={'confirm'}
                            medium
                            style={{width: 180}}
                            title={'Cancel'}
                            onClick={() => props.setIsChangeEmailProcess(false)}
                            icon={<Icon component={() => <Back/>} rev={undefined}/>}
                            personalAccount={true}
                        />
                        <MyBtn
                            buttonType={'confirm'}
                            medium
                            style={{width: 180}}
                            title={'Next'}
                            type={"submit"}
                            personalAccount={true}
                        />
                    </div>
                </form>
            </CustomModal>

            <CustomModal isModalOpen={isVerifyModalOpen} setIsModalOpen={setIsVerifyModalOpen} type={"confirm"}>
                <form onSubmit={formikEmailVerify.handleSubmit} className={s.from_wrapper}>
                    <div className={s.modal_title}>
                        SMS authentication
                    </div>
                    <div className={s.modal_subtitle}>
                        Email with confirmation code was sent to your email address <b>{newEmail}</b>
                    </div>
                    <div className={s.input_block}>
                        <div className={s.input_label}>
                            confirmation Code
                        </div>
                        <MyInput
                            value={formikEmailVerify.values.code}
                            onChange={formikEmailVerify.handleChange}
                            id={"code"}
                            name={"code"}
                        />
                    </div>
                    <div className={s.buttonsWrapper}>
                        <TransparentButton
                            buttonType={'confirm'}
                            medium
                            style={{width: 180}}
                            title={'Cancel'}
                            onClick={() => setIsVerifyModalOpen(false)}
                            icon={<Icon component={() => <Back/>} rev={undefined}/>}
                        />
                        <MyBtn
                            buttonType={'confirm'}
                            medium
                            style={{width: 180}}
                            title={'Confirm'}
                            type={"submit"}
                        />
                    </div>
                </form>
            </CustomModal>

            <CustomModal isModalOpen={isErrorModalOpen} setIsModalOpen={setIsErrorModalOpen} type={"error"}>
                <div className={s.from_wrapper}>
                    <div className={s.modal_title}>
                        Oops!
                    </div>
                    <div className={s.modal_subtitle}>
                        {isErrorText}
                    </div>
                    <div className={s.buttonsWrapper}>
                        <MyBtn
                            buttonType={'error'}
                            medium
                            style={{width: 180}}
                            title={'Ok'}
                            onClick={() => setIsErrorModalOpen(false)}
                        />
                    </div>
                </div>
            </CustomModal>
        </>
    );
};

export default ChangeEmail;
